module.exports = __webpack_public_path__ + "img/title.2ce39ac9.png";